import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox } from "primereact/checkbox";




import { Button } from '../../../helpers';

import { getDateString } from '../../../utils';
import { getPMCompanyConfig } from '../../../setup/pmCompanyConfig';


const PIPunchConfirmDialog = (props) => {
    const { PIPunchSubmitData, selectedPMBillAddr, sellerBillAddrDetails, sellerPO, piPunchImageName } = props
    const { sellerPIPunch } = PIPunchSubmitData

    const [sellerGSTINDeclaration, setSellerGSTINDeclaration] = useState(false)
    const [PMGSTINDeclaration, setPMGSTINDeclaration] = useState(false)
    const [PINoDeclaration, setPINoDeclaration] = useState(false)
    const [PIDateDeclaration, setPIDateDeclaration] = useState(false)
    const [PIAmountDeclaration, setPIAmountDeclaration] = useState(false)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const canPIPunch = sellerGSTINDeclaration && PMGSTINDeclaration && PINoDeclaration && PIDateDeclaration && PIAmountDeclaration

    return (
        <>
            {piPunchImageName && <iframe title='pdf viewer' style={{ height: "67%", width: "100%" }} src={piPunchImageName.url} />}
            <div className="mt-3">
                <div className="flex flex-row mb-2">
                    <Checkbox onChange={e => setSellerGSTINDeclaration(e.checked)} checked={sellerGSTINDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >Seller {pmCompanyConfig.GSTINLabel}:<span className="font-bold ml-1">{sellerBillAddrDetails.gstinCode}</span></label>
                </div>
                <div className="flex flex-row mb-2">
                    <Checkbox onChange={e => setPMGSTINDeclaration(e.checked)} checked={PMGSTINDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >Procmart {pmCompanyConfig.GSTINLabel}:<span className="font-bold ml-1">{selectedPMBillAddr.gstinCode}</span></label>
                </div>
                <div className="flex flex-row mb-2">
                    <Checkbox onChange={e => setPINoDeclaration(e.checked)} checked={PINoDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >PI Number:<span className="font-bold ml-1">{sellerPIPunch.sellerPINumber}</span></label>
                </div>
                <div className="flex flex-row mb-2">
                    <Checkbox onChange={e => setPIDateDeclaration(e.checked)} checked={PIDateDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >PI Date:<span className="font-bold ml-1">{getDateString(sellerPIPunch.sellerPIDate)}</span></label>
                </div>
                <div className="flex flex-row mb-2">
                    <Checkbox onChange={e => setPIAmountDeclaration(e.checked)} checked={PIAmountDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >PI Amount:<span className="font-bold ml-1">{sellerPIPunch.sellerPICalculatedTotalAmount}</span></label>
                </div>
                <div className="mt-2 flex flex-row justify-content-center mt-2">
                    <Button label="Confirm" applyThrottle disabled={sellerPO.isAllProcessed || sellerPO.statusId === 6 || !canPIPunch} permissions={[19, 20]} onClick={() => props.handlePIPunchConfirmModal(sellerGSTINDeclaration, PMGSTINDeclaration, PINoDeclaration, PIDateDeclaration, PIAmountDeclaration)} />
                </div>
            </div>
        </>
    )
}

export default PIPunchConfirmDialog